import { Pagination } from "rsuite";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import { httpRequest } from "utils/httpRequest";
import CircleLoader from "components/loader/CircleLoader";
import { useLoader } from "components/loader/useLoader";

export default function CityPage() {
  const [modal, setModal] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const { id } = useParams();
  const { loading, startLoading, stopLoading } = useLoader();

  const toggle = () => setModal(!modal);

  const validationSchema = Yup.object({
    city: Yup.string()
      .trim()
      .required("City name is required")
      .min(2, "City name must be at least 2 characters"),
  });

  const formik = useFormik({
    initialValues: {
      city: "",
    },
    validationSchema,

    onSubmit: async (values, { resetForm }) => {
      console.log("Form submitted with:", values);

      try {
        const response = await httpRequest(
          "statecity/add-city",
          "POST",
          {
            name: values.city,
            state: id,
          },
          {},
          true,
          true
        );

        if (response.code === 200) {
          toast.success("City added successfully.");
          resetForm();
          setModal(!modal);
          getCityList();
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  const getCityList = async (page = activePage) => {
    startLoading();
    try {
      const response = await httpRequest(
        "statecity/get-city",
        "GET",
        {},
        { state: id, offset: (page - 1) * limit, limit: limit },
        true,
        false
      );

      if (response.code === 200) {
        setCityList(response.data);
        setTotal(response?.count);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      stopLoading();
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    getCityList(page);
  };

  const handleDelete = async (id) => {
    try {
      const response = await httpRequest(
        `statecity/delete-city/${id}`,
        "DELETE",
        {},
        {},
        true,
        true
      );
      if (response?.code === 200) {
        toast.success("City deleted successfully");
        getCityList();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    if (id) {
      getCityList();
    }
  }, [id]);

  return (
    <>
      {loading ? (
        <CircleLoader />
      ) : (
        <div className="container-fluid py-4 mt-5">
          <div className="row">
            <div className="col">
              <div className="card shadow">
                {/* Card Header */}
                <div className="card-header border-0 d-flex justify-content-end">
                  <h3 className="mb-0 mr-auto">City</h3>
                  {/* <Button color="primary" size="sm" onClick={handleNavigationOnAddArticle}> */}
                  <Button color="primary" size="sm" onClick={toggle}>
                    Add City
                  </Button>
                </div>

                {/* Table */}
                <div className="table-responsive">
                  <table className="table align-items-center table-flush">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">City</th>

                        <th scope="col">Action</th>

                        {/* <th scope="col">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {cityList &&
                        cityList.length > 0 &&
                        cityList.map((item, index) => (
                          <tr key={item._id}>
                            <td>
                              <span className="mb-0 text-sm font-weight-bold">
                                {(activePage - 1) * limit + index + 1}
                              </span>
                            </td>
                            <td>
                              <span className="mb-0 text-sm font-weight-bold">
                                {item?.name}
                              </span>
                            </td>

                            <td>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => {handleDelete(item._id)}}
                                title="Delete"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Modal */}
                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={toggle}>Add City</ModalHeader>
                  <ModalBody>
                    <form onSubmit={formik.handleSubmit}>
                      <FormGroup>
                        <Label for="addcity">City</Label>
                        <Input
                          id="addcity"
                          name="city"
                          placeholder="Enter City"
                          type="text"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={formik.touched.city && !!formik.errors.city}
                        />
                        {formik.touched.city && formik.errors.city && (
                          <div className="text-danger">
                            {formik.errors.city}
                          </div>
                        )}
                      </FormGroup>

                      <ModalFooter>
                        <Button color="primary" type="submit">
                          Add
                        </Button>{" "}
                        <Button color="secondary" onClick={toggle}>
                          Cancel
                        </Button>
                      </ModalFooter>
                    </form>
                  </ModalBody>
                </Modal>

                {/* Card Footer with Pagination */}
                <div className="card-footer py-4">
                  <div className="d-flex justify-content-end">
                    <Pagination
                      size="sm"
                      total={total} // backend-provided total count
                      limit={limit} // we control this (useState)
                      activePage={activePage}
                      onChangePage={handlePageChange}
                      maxButtons={5}
                      prev
                      next
                      last
                      first
                      ellipsis
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
